import {
  Users,
  Gauge,
  ClipboardCheck,
  Calendar,
  Dumbbell,
  Trophy,
  SquarePlus,
  Box,
  Laptop,
  Kanban,
} from "lucide-react";

export const GetPropsHeader = (path) => {
  var pathName = "";
  var pathIcon = "";
  switch (path) {
    case "/app/admin/managerial":
    case "/app/customer/managerial":
      pathName = "Painel Gerencial";
      pathIcon = (
        <Kanban
          color="#9FA1AA"
          size={15}
          style={{ marginBottom: "-2px", marginRight: "5px" }}
        />
      );
      break;

    case "/app/admin/users":
      pathName = "Acessos";
      pathIcon = (
        <Laptop
          color="#9FA1AA"
          size={15}
          style={{ marginBottom: "-2px", marginRight: "5px" }}
        />
      );
      break;

    default:
      break;
  }
  return { pathName, pathIcon };
};
